import { useEffect, useState } from "react";
import "./SlidingTimeoutBar.css";

export function SlidingTimeoutBar({
  isActive,
  duration = 3000,
  className = "",
}) {
  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    if (isActive) {
      setAnimationKey((prev) => prev + 1);
    }
  }, [isActive, duration]);

  return (
    <div className={`toast-timeout-bar ${className}`.trim()} aria-hidden="true">
      <div
        key={animationKey}
        className="toast-timeout-bar__fill"
        style={{ animationDuration: `${duration}ms` }}
      />
    </div>
  );
}
